module.exports = __webpack_public_path__ + "static/img/hdzq.85a1163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hdzq.png
// module id = qCyG
// module chunks = 4